import {createContext, useContext} from "react";

export const SceneIdContext = createContext(null);

export const useSceneId = () => useContext(SceneIdContext);
